module.exports = __webpack_public_path__ + "img/ic_12_plus_blue.ed1df410.svg";